import React from "react";
import "./EmptyList.css";

const EmptyList = ({ text }) => {
  return <div className="bg-white rounded-10 p-5 emptyList bold f24 text-grey">{text}</div>;
};

export default EmptyList;
